import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/timer-off.vue
var s = {
	name: "DtIconTimerOff",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--timer-off"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Timer Off",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", {
		"clip-path": `url(#${e.uniqueID}a)`,
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		fill: "currentColor"
	}, [...t[0] || (t[0] = [i("path", { d: "M4.5 1A.5.5 0 0 1 5 .5h2a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5ZM2.492 5.038a.5.5 0 0 1 .27.654 3.5 3.5 0 0 0 .742 3.804 3.5 3.5 0 0 0 3.804.742.5.5 0 1 1 .384.924 4.5 4.5 0 0 1-4.894-.957l-.003-.003a4.5 4.5 0 0 1-.957-4.894.5.5 0 0 1 .654-.27Zm3.923-2.531A4.5 4.5 0 0 1 9.207 3.85a4.5 4.5 0 0 1 .728 5.378l1.419 1.418a.5.5 0 0 1-.708.708l-10-10a.5.5 0 1 1 .708-.708l2.418 2.42a4.5 4.5 0 0 1 2.643-.558Zm2.08 2.046a3.5 3.5 0 0 1 .697 3.932L6.5 5.793V5a.5.5 0 0 0-.968-.175L4.515 3.808a3.5 3.5 0 0 1 3.976.74l.004.005Z" }, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=timer-off.js.map